module.exports = __webpack_public_path__ + "img/pic1.8e8bbb1.webp";